import { activityPeriod, validDateKey } from './activity-model.js';

// Calendar-only date keys: no phone timezone conversion or typed date parsing.
export function calendarMonth(date) {
  const {days,startDate}=activityPeriod('month',date);
  const offset=(new Date(`${startDate}T12:00:00Z`).getUTCDay()+6)%7;
  const cells=[...Array(offset).fill(null),...days];
  while(cells.length%7)cells.push(null);
  return cells;
}
export function adjacentMonth(date,delta) {
  if(!validDateKey(date)||![-1,1].includes(delta))throw new Error('invalid_calendar_month');
  const next=new Date(`${date.slice(0,7)}-01T12:00:00Z`);
  next.setUTCMonth(next.getUTCMonth()+delta);
  const key=next.toISOString().slice(0,10);
  return validDateKey(key)?key:date.slice(0,7)+'-01';
}
